import Modal, { ModalProps } from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";

import { useApi } from "@/hooks/useApi";

import { useSwal } from "@/hooks/useSwal";
import { transformData } from "@/utils/transformData";
import { procedureMap } from "@/utils/mappings/procedure";

import { FormattedFormControl } from "@/components/FormControl/FormattedFormControl";
import { ProceduresSelect } from "@/components/Selects/ProceduresSelect";

type Props = ModalProps & {
	setProcedures: (procedures: Procedure[]) => void;
	permitId: number;
};

export function ModalAddProcedures({ setProcedures, permitId, ...rest }: Props) {
	const { Toast } = useSwal();
	const { api } = useApi();

	async function handleAddProcedure() {
		try {
			const formProcedure = document.getElementById("form-procedure") as HTMLFormElement;

			const formData = new FormData(formProcedure);

			const { data } = await api.post(
				`/hospitalization-permits/${permitId}/procedures`,
				formData
			);

			const transformedProcedures = transformData<Procedure[]>(data.procedures, procedureMap);

			setProcedures(transformedProcedures);

			rest.onHide?.();

			Toast.fire({
				text: "Procedimento adicionado com sucesso.",
				icon: "success",
			});
		} catch (error) {
			console.log(error);

			Toast.fire({
				text: "Não foi possível adicionar este procedimento.",
				icon: "error",
			});
		}
	}

	return (
		<Modal {...rest}>
			<Modal.Header className="d-flex justify-content-center">
				<Modal.Title>Adicionar Procedimentos</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Form id="form-procedure">
					<Form.Label>Selecione um procedimento</Form.Label>
					<ProceduresSelect name="procedure_code" className="mb-1" />

					<FormattedFormControl
						name="quantity"
						mask="0000"
						isMaskedInput
						label="Quantidade"
						formattedFormControlClassName="form-control-solid"
					/>
				</Form>
			</Modal.Body>
			<Modal.Footer className="d-flex justify-content-center gap-2">
				<Button variant="light" onClick={() => rest.onHide?.()}>
					Cancelar
				</Button>
				<Button onClick={handleAddProcedure}>Adicionar</Button>
			</Modal.Footer>
		</Modal>
	);
}
